import axios from 'axios';

async function ObtenerRubro(prmIdRubro: number) {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_rubro"
    
    try {
        const response = await axios.post(url, {
            "usuario": "mpatti",
            "clave": "all2GetHer_!",
            "id_rubro": prmIdRubro
        });
        return response.data;
    } catch (error) {
        return error;
    }
};

export default ObtenerRubro;